<template>
	<div class="create-customer">
		<van-form ref="form" @submit="handleSubmit">
			<van-field v-model="formData.customerName"
				:rules="[{ required: true, message: '请输入客户姓名', trigger: 'onBlur' }]" label="客户姓名"
				placeholder="请输入客户姓名" />
			<van-field v-model="formData.customerTel" label="手机号" placeholder="请输入手机号" :rules="[
          { required: true, message: '请填写客户手机号', trigger: 'onBlur' },
          { pattern: telPattern, message: '请输入正确的手机号' }
        ]" />
			<van-field :value="followUpPerson" label="跟进人" placeholder="请选择跟进人" readonly
				@click="showStaffPick = true" />
			<van-field :value="courseFollowUpPerson" label="课程服务人" placeholder="请选择课程服务人" readonly
				@click="showFollowPick = true" />
			<van-field v-model="formData.customerIdCard" label="身份证号" placeholder="请输入身份证号" />
			<van-field v-model="formData.wechatNum" label="微信号" placeholder="请输入微信号" />
			<!-- <van-field v-model="formData.tiktokNum" label="抖音号" placeholder="多个以逗号分隔" /> -->
			<van-field v-model="formData.qqNum" label="QQ号" placeholder="请输入QQ号" />
			<van-field v-model="formData.remark" label="备注" maxlength="200" placeholder="请输入备注" />
			<div class="region-list">
				<p class="border-bottom">所属机构</p>
				<van-field name="org">
					<template #input>
						<ul class="list">
							<li class="border-bottom region-item" v-for="(item, index) in formData.org" :key="index">
								<van-icon name="close" @click="removeRegion(index)" />
								<span @click="modifyRegion('edit', item, index)">{{ item.orgName }}</span>
							</li>
							<li class="add border-bottom">
								<van-icon name="add-o" @click="modifyRegion('add')" />
								<span @click="modifyRegion('add')">添加机构</span>
							</li>
						</ul>
					</template>
				</van-field>
			</div>
			<div class="footer">
				<van-button size="small" native-type="submit">{{ customerId ? '编辑客户' : '创建客户' }}</van-button>
			</div>
		</van-form>
		<Region v-if="showRegion" :value="currentRegion" :visible.sync="showRegion" @saveRegion="handleRegion" />
		<StaffModal :visible.sync="showStaffPick" :staffList="staffList" @modifyUserId="modifyUserId" />
		<StaffModal :visible.sync="showFollowPick" :staffList="staffList" @modifyUserId="followUserId" />
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		createCustomer,
		getCustomerInfo,
		updateCustomer
	} from '@/api/customer'
	import {
		telRegExp
	} from '@/utils'
	import StaffModal from '@/views/orders/staffModal'
	import Region from '@/components/region'
	export default {
		name: 'CreateCustomer',
		components: {
			StaffModal,
			Region
		},
		data() {
			return {
				telPattern: telRegExp,
				showStaffPick: false,
				showFollowPick:false,
				showRegion: false,
				followUpPerson: '',
				courseFollowUpPerson:'',
				formData: {
					customerName: '', // 顾客姓名
					customerTel: '', // 顾客电话
					customerIdCard: '', // 顾客身份证
					wechatNum: '', // 微信号
					tiktokNum: '', //抖音号
					remark: '',
					followUpPersonId: '', // 跟进人
					courseFollowUpPersonId:'',//课程服务人
					org: [], // 机构
					qqNum:"",
				},
				currentRegion: {}, // 当前修改的机构
				modifyRegionIndex: null
			}
		},
		computed: {
			...mapGetters(['staffList', 'userInfo']),
			customerId() {
				return this.$route.query.customerId
			},
		},
		watch: {
			userInfo: {
				handler(val) {
					// this.followUpPerson = val.name
					// this.formData.followUpPersonId = val.id
				},
				deep: true,
				immediate: true
			}
		},
		created() {
			if (!this.staffList || !this.staffList.length) {
				this.$store.dispatch('user/getStaffList', {
					page: 1,
					count: 1000
				})
			}
			if (this.customerId) {
				this.getCustomerInfo()
			}
		},
		methods: {
			handleSubmit() {
				const {
					wechatNum,
					followUpPersonId,
					courseFollowUpPersonId,
					customerIdCard,
					org
				} = this.formData;
				const params = {
					...this.formData,
					wechatNum: wechatNum || undefined,
					followUpPersonId: followUpPersonId || undefined,
					courseFollowUpPersonId: courseFollowUpPersonId || 0,
					customerIdCard: customerIdCard || undefined,
					org: org.length ? org : undefined
				};
				if (this.customerId) { // 修改客户信息还是创建
					updateCustomer({
						...params,
						id: Number(this.customerId)
					}).then((res) => {
						if (res.errcode === 0) {
							this.$toast.success('修改顾客信息成功')
							this.$router.go(-1); // 返回跳转修改客户页面
						}
					})
				} else {
					createCustomer(params).then((res) => {
						if (res.errcode === 0) {
							this.$toast.success('创建顾客成功')
							this.$router.go(-1); // 返回跳转创建客户页面
						}
					})
				}
			},
			modifyUserId(user) {
				this.formData.followUpPersonId = user.id
				this.followUpPerson = user.name
			},
			followUserId(user){
				this.formData.courseFollowUpPersonId = user.id
				this.courseFollowUpPerson = user.name
			},
			handleRegion(val) {
				if (this.modifyRegionIndex !== null) { // 修改当前机构
					this.formData.org.splice(this.modifyRegionIndex, 1, val)
				} else {
					this.formData.org.push(val)
				}
			},
			removeRegion(index) {
				this.formData.org.splice(index, 1)
			},
			modifyRegion(type, item, index) {
				this.showRegion = true
				if (type === 'add') {
					this.modifyRegionIndex = null
					this.currentRegion = {}
				} else {
					this.currentRegion = item
					this.modifyRegionIndex = index
				}
			},
			getCustomerInfo() { // 获取用户信息
				getCustomerInfo({
					id: Number(this.customerId)
				}).then((res) => {
					if (res.errcode === 0) {
						const {
							customerOrg,
							customerName,
							customerTel,
							customerIdCard,
							wechatNum,
							tiktokNum,
							followUpPerson,
							courseFollowUpPerson,
							remark
						} = res.data
						this.formData = {
							org: customerOrg,
							customerName, // 顾客姓名
							customerTel, // 顾客电话
							customerIdCard, // 顾客身份证
							wechatNum, // 微信号
							tiktokNum, //抖音号
							remark,
							followUpPersonId: followUpPerson.id ,// 跟进人
							courseFollowUpPersonId:courseFollowUpPerson.id
						}
						this.followUpPerson = followUpPerson.name
						this.courseFollowUpPerson = courseFollowUpPerson.name
						document.title = '编辑客户信息'
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.create-customer {
		background-color: #fff;
		overflow: auto;

		.region-list {
			margin: 0 16px;

			.van-field {
				padding: 0;
			}

			p {
				color: #646666;
				padding: 15px 0;
			}

			.list {
				width: 100%;

				li {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 10px 0;
				}

				.region-item {
					.van-icon-close {
						cursor: pointer;
						color: #ee0a24;
					}

					span {
						color: #646566;
					}
				}

				.add {
					.van-icon-add-o {
						color: rgba(128, 128, 128, .8);
						cursor: pointer;
					}

					span {
						color: rgba(128, 128, 128, .8);
					}
				}
			}
		}

		.footer {
			margin: 10px 0;
			text-align: center;
		}
	}
</style>
